import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/alat-reuse";

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

// Master
const masterList = (params?: any) =>
  handle(http.getDataParam(`${BASE}/master`, params));
const masterCreate = (data: any) => handle(http.postData(`${BASE}/master`, data));
const masterUpdate = (id: number, data: any) =>
  handle(http.putData(`${BASE}/master/${id}`, data));
const masterDestroy = (id: number) =>
  handle(http.deleteData(`${BASE}/master/${id}`));

// Penggunaan
const penggunaanList = (params?: any) =>
  handle(http.getDataParam(`${BASE}/penggunaan`, params));
const penggunaanCreate = (data: any) =>
  handle(http.postData(`${BASE}/penggunaan`, data));
const penggunaanUpdate = (id: number, data: any) =>
  handle(http.putData(`${BASE}/penggunaan/${id}`, data));
const penggunaanDestroy = (id: number) =>
  handle(http.deleteData(`${BASE}/penggunaan/${id}`));

// Status preview untuk chip hijau/kuning/merah
const penggunaanStatus = (masterAlatId: number, kodeUnitAlat?: string) =>
  handle(
    http.getDataParam(`${BASE}/penggunaan-status`, {
      params: {
        master_alat_reuse_id: masterAlatId,
        kode_unit_alat: kodeUnitAlat || ""
      }
    })
  );

// Kerusakan
const kerusakanList = (params?: any) =>
  handle(http.getDataParam(`${BASE}/kerusakan`, params));
const kerusakanCreate = (data: any) =>
  handle(http.postData(`${BASE}/kerusakan`, data));
const kerusakanUpdate = (id: number, data: any) =>
  handle(http.putData(`${BASE}/kerusakan/${id}`, data));
const kerusakanDestroy = (id: number) =>
  handle(http.deleteData(`${BASE}/kerusakan/${id}`));

// PDF (opened via window.open with query string)
function buildQuery(params: Record<string, any>) {
  const esc = (v: any) => encodeURIComponent(String(v));
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${esc(k)}=${esc(v)}`);
  return parts.length ? "?" + parts.join("&") : "";
}
const printPenggunaanPdf = (filters: Record<string, any> = {}) => {
  const qs = buildQuery(filters);
  window.open(`${http.getAPI()}${BASE}/laporan/penggunaan/pdf${qs}`, "_blank");
};
const printKerusakanPdf = (filters: Record<string, any> = {}) => {
  const qs = buildQuery(filters);
  window.open(`${http.getAPI()}${BASE}/laporan/kerusakan/pdf${qs}`, "_blank");
};

export default {
  masterList,
  masterCreate,
  masterUpdate,
  masterDestroy,
  penggunaanList,
  penggunaanCreate,
  penggunaanUpdate,
  penggunaanDestroy,
  penggunaanStatus,
  kerusakanList,
  kerusakanCreate,
  kerusakanUpdate,
  kerusakanDestroy,
  printPenggunaanPdf,
  printKerusakanPdf
};
